module.exports = __webpack_public_path__ + "355CC9_2_0.ttf?ad095ebd2d94e1058afbd66c12d33557";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_2_0.ttf
// module id = 39
// module chunks = 0